import { Component, ElementRef, TemplateRef, Input, ViewChild, OnInit, OnChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../app.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { qmsService } from '../qms/qms.service';
import { DatePipe } from '@angular/common';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from '../message.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { EditorComponent } from '../editor/editor.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
export interface PopupData {
  title: string;
}
@Component({
  selector: 'app-dms-reports',
  templateUrl: './dms-reports.component.html',
  styleUrls: ['./dms-reports.component.scss']
})
export class DMSReportsComponent implements OnInit, OnChanges {
  intervalValueDropdown: any = [];
  isProcessing: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  selectedOption: any;
  selectedStatusValue: any = [];
  physicalFolderLevel: boolean = true;
  distributedFolderLevel: boolean = true;
  includeAmendmentsFlg: boolean = true;
  associatedDocFlg: boolean = true;
  individualDocFlg: boolean = true;
  specificIntervalVal: boolean = false;
  documentTypeDropdown: any = [];
  selectedDocumentType: any = [];
  selectedDocumentTypeValue: any = "";
  dropDownFordocumentTypeList: any = [];
  selectedGroupValue: any = [];
  groupdataList: any = [];
  showSpecificInterval: boolean = false;
  fromDate: any;
  toDate: any;
  pagedItems1: any = [];
  statusValueDropdown: any = [];
  dropDownForInterval: any = [];
  selectedIntervalValue: any = []
  selectedDateRangeValue: any = [];
  dateRangeValueDropdown: any = [];
  dropDownForDateRange: any = [];
  showTables: boolean = false;
  showNoRecordFoundMasterIndex: boolean = false;
  showNoRecordFoundInventry: boolean = false;
  showNoRecordFoundMilestone: boolean = false;
  showNoRecordFoundFolderDocuments: boolean = false;
  showNoRecordFoundExpireheck: boolean = false;
  dateCustomClasses: DatepickerDateCustomClasses[];
  documentNo: any;
  documentTypeSearchText: string = '';
  pdfSearchText: string = '';
  htmlContent: any;
  dynamicGridName: any;
  dynamicGridViewName: any;
  snackbarRef: any;
  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  tmsUserTrainingsRepVwDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  stageValueDropdown: any = [];
  stageAndStatus: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  tableReportDataList: any = [];
  tableReportExpireCheckList: any = [];
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  users: any[];
  pager: any = {};
  filteredGridData: any = [];
  pagedItems: any = [];
  pagedItems2: any = [];
  error = '';
  visibleAddButton: boolean;
  visibleEditButton: boolean;
  selectedFolderPath: any;
  selectedDocumentTypeName: any;
  selectedDocContainer: any;
  getSelectedTaskId: any;
  getSelectedTaskNo: any;
  getTaskDetailsObj: any = [];
  getTaskDetailsObj1: any = [];
  privvalue: any;
  whereValsForExcel: any;
  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  selectedUser: any;
  isForExcel: boolean = false;
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  data: any = {};
  data1: any = {};
  data2: any = {};
  columnSearchValues: any = {};
  private searchSubject = new Subject<{ column: string, filterValue: string, val: any }>();

  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;

  @ViewChild('searchTaskVW', { static: true }) searchTaskVW: TemplateRef<any>;
  visibleSearchTaskVwPopup: MatDialogRef<TemplateRef<any>>;

  constructor(public dialog: MatDialog, public route: ActivatedRoute, public appService: AppService, public router: Router, public snackBar: MatSnackBar,
    public elem: ElementRef, public qmsservice: qmsService, public paginationService: PaginationService, public message: messageService, public datePipe: DatePipe, public activatedRoute: ActivatedRoute) {
    appService.isProcessingRep = false;
  }

  @ViewChild(BreadcrumbComponent) breadcrumbComponent!: BreadcrumbComponent;

  dmsGroupFoldersFieldData: any = {};
  visibleSearchFoldersPopup: MatDialogRef<TemplateRef<any>>;
  visibleDmsGroupFoldersReasonForUpdateField: boolean;
  @ViewChild('searchFoldersPopup', { static: true }) searchFoldersPopup: TemplateRef<any>;
  searchFoldersPopupConfig = {
    width: '60%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  @ViewChild('documentType') documentType: MatSelect;
  documentTypeSelection = false;
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  @ViewChild('documentType') newDocumentType: MatSelect;
  newdocumentTypeSelection = false;
  @ViewChild('pdf') pdf: MatSelect;
  pdfSelection = false;
  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: false,
    itemsShowLimit: 1,
  };
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  ondocumentTypeSelectnew(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (Array.isArray(this.selectedDocumentType)) {
          this.documentTypeSelection = this.selectedDocumentType.length > 0 && !this.selectedDocumentType.some(item => Number.isNaN(item));
        } else {
          this.documentTypeSelection = false; // or handle the case when it's not an array
        }
      })
    }
  }
  toggleAllSelection(value: any) {
    if (value == 'newDocumentType') {
      if (this.newdocumentTypeSelection) this.newDocumentType.options.forEach((item: MatOption) => item.select());
      else {
        this.newDocumentType.options.forEach((item: MatOption) => item.deselect())
        this.selectedDocumentType = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('initial-complaint-category-validation', this.selectedDocumentType)
      });

    } else if (value == 'pdf') {
      if (this.pdfSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });
    } else if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }
  operationFlag: any
  oneQmsUsersFieldData: any = {};
  popupDataTitle: PopupData = {
    title: ''
  };
  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }
  addFolderFunction() {
    if (this.selectedFolderForCreateDoc) {
      this.dmsGroupFoldersFieldData.folderPath = this.selectedFolderForCreateDoc.path;
      this.dmsGroupFoldersFieldData.folderName = this.selectedFolderForCreateDoc.path;
      this.message.dmsReportButtonVal == 'Master Index' && this.onNgModelChange(this.dmsGroupFoldersFieldData.folderName, 'folderMasterAlert')
      if (this.operationFlag == 'ADD') {
        this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Create DMS Group Folder" : "";
      } else {
        this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Update DMS Group Folder" : "";
      }
      this.visibleSearchFoldersPopup.close();
    }
  }
  model = {
    documentData: {},
  };
  selectedFolderForCreateDoc: any = {};
  changeInFolderStructureChild(data: any) {
    this.model = data;
    this.selectedFolderForCreateDoc = this.model.documentData;
  }
  cancelSeachFoldersFunction() {
    if (this.operationFlag == 'ADD') {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Create DMS Group Folder" : "";
    } else {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Update DMS Group Folder" : "";
    }
    this.visibleSearchFoldersPopup.close();
  }
  showPhysicalFolderLevel(e: any) {
    if (e.target.checked) {
      this.physicalFolderLevel = true;
    } else {
      this.physicalFolderLevel = false;
    }
  }
  showDstributedFolderLevel(e: any) {
    if (e.target.checked) {
      this.distributedFolderLevel = true;
    } else {
      this.distributedFolderLevel = false;
    }
  }
  getDmsFoldersVwDetails: any = [];
  searchDocumentFunction() {
    this.popupDataTitle.title = "Search Folders";
    this.visibleSearchFoldersPopup = this.dialog.open(this.searchFoldersPopup, this.searchFoldersPopupConfig);
  }
  showIncludeAmendmentsFlg(e: any) {
    if (e.target.checked) {
      this.includeAmendmentsFlg = true;
    } else {
      this.includeAmendmentsFlg = false;
    }
  }
  showAssociatedDocFlg(e: any) {
    if (e.target.checked) {
      this.associatedDocFlg = true;
    } else {
      this.associatedDocFlg = false;
    }
  }
  showIndividualFlg(e: any) {
    if (e.target.checked) {
      this.individualDocFlg = true;
    } else {
      this.individualDocFlg = false;
    }
  }
  //dynamic grid
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName,
    }
    let clobApi: any;
    clobApi = this.appService.getClobToViewDistributed(docObj);
    this.htmlContent = "";
    clobApi.subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    })
    this.isProcessing = false;
  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || (this.pager.totalPages && page > this.pager.totalPages)) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.filteredGridData.length, page, this.perPage, targetpage);
    if (this.filteredGridData.length > 0) {
      this.pagedItems = this.filteredGridData
        .slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }
  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getcallMethodPendingTasks() {

    this.isProcessing = true;

    if (this.selectedFolderPath == "Repository") {
      this.selectedFolderPath = null;
    }
    this.tmsUserTrainingsRepVwDataForGrid = [];
    const data = {

      gridName: this.dynamicGridName,
      groupId: null
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause = response.orderByClause || "";
        this.makeStickyColumns = response.fixedFieldCnt;
        let data1: any;
        this.selectedFolderPath = this.selectedFolderForCreateDoc.folderPath;
        data1 = {

          gridName: this.dynamicGridViewName,
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          selectedUserId: this.oneQmsUsersFieldData.managerId ? this.oneQmsUsersFieldData.managerId.toString() : null,
          selectedFolderPath: this.selectedFolderPath,
          selectedDocumentTypeName: null,
          selectedDocContainer: null,
          module: "DOCS",
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.isProcessing = false;
            this.tmsUserTrainingsRepVwDataForGrid = response1;
            this.filteredGridData = response1;
            this.showNoRecordFoundInventry = this.tmsUserTrainingsRepVwDataForGrid.length === 0;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }
            for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
              if (this.columnLists.invisibleColumnarray.includes(this.columnLists.columnsListarray[y])) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const record of this.tmsUserTrainingsRepVwDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    record[dataType.columnName] = record[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.tmsUserTrainingsRepVwDataForGrid;
            this.collectionSize = this.tmsUserTrainingsRepVwDataForGrid.length;
            this.setPage(1, 0);
            this.totalPages = Math.ceil(this.tmsUserTrainingsRepVwDataForGrid.length / this.itemsPerPage);
          }, error: (error: any) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });

  }
  getcallMethod() {
    this.isProcessing = true;
    if (this.selectedDocumentType.length != 0) {
      this.selectedDocumentTypeName = "";
      const codesArray: string[] = this.selectedDocumentType.join(',').split(",");
      for (const code of codesArray) {
        this.selectedDocumentTypeName += `'${code.trim()}',`;
      }
      // To remove the trailing comma, you can do:
      this.selectedDocumentTypeName = this.selectedDocumentTypeName.slice(0, -1);
    } else {
      this.selectedDocumentTypeName = null;
    }
    if (this.selectedFolderPath == "Repository") {
      this.selectedFolderPath = null;
    }
    this.tmsUserTrainingsRepVwDataForGrid = [];
    const data = {

      gridName: this.dynamicGridName,
      groupId: null
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause = response.orderByClause ?? "";
        this.makeStickyColumns = response.fixedFieldCnt;
        let data1: any;
        if (this.message.dmsReportButtonVal == 'Inventory') {
          data1 = {

            gridName: this.dynamicGridViewName,
            tableOrViewName: response.tableOrViewName ?? "",
            columnsList: response.columnsList ?? "",
            fieldLabelsList: response.fieldLabelsList ?? "",
            invisibleColumn: response.invisibleColumn ?? "",
            orderByClause: response.orderByClause ?? "",
            fieldSizeList: response.fieldSizeList ?? "",
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            selectedUserId: this.oneQmsUsersFieldData.managerId,
            selectedFolderPath: this.selectedFolderPath,
            selectedDocumentTypeName: this.selectedDocumentTypeName,
            selectedDocContainer: this.selectedDocContainer,
            manualEntryDataFields: response.manualEntryDataFields,
            clobColumnlist: response.closblist || "",
            blobColumnlist: response.bloblist || ""
          }
        } else {
          data1 = {

            gridName: this.dynamicGridViewName,
            tableOrViewName: response.tableOrViewName ?? "",
            columnsList: response.columnsList ?? "",
            fieldLabelsList: response.fieldLabelsList ?? "",
            invisibleColumn: response.invisibleColumn ?? "",
            orderByClause: response.orderByClause ?? "",
            fieldSizeList: response.fieldSizeList ?? "",
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            selectedUserId: null,
            selectedFolderPath: null,
            selectedDocumentTypeName: null,
            selectedDocContainer: null,
            manualEntryDataFields: response.manualEntryDataFields,
            clobColumnlist: response.closblist || "",
            blobColumnlist: response.bloblist || "",
            type: this.message.dmsReportButtonVal
          }
        }
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.isProcessing = false;
            this.tmsUserTrainingsRepVwDataForGrid = response1;
            this.filteredGridData = response1;
            this.showNoRecordFoundInventry = this.tmsUserTrainingsRepVwDataForGrid.length === 0;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }
            for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
              if (this.columnLists.invisibleColumnarray.includes(this.columnLists.columnsListarray[y])) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const record of this.tmsUserTrainingsRepVwDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    record[dataType.columnName] = record[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.tmsUserTrainingsRepVwDataForGrid;
            this.collectionSize = this.tmsUserTrainingsRepVwDataForGrid.length;
            this.setPage(1, 0);
            this.totalPages = Math.ceil(this.tmsUserTrainingsRepVwDataForGrid.length / this.itemsPerPage);
          }, error: (error: any) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  applyFilter3(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems1 = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems1 = this.tableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, this.appService.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter5(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems2 = this.tableReportExpireCheckList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems2 = this.tableReportExpireCheckList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, this.appService.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }

  applyFilter4(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems1 = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems1 = this.tableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, this.appService.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter6(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.getTaskDetailsObj1 = this.getTaskDetailsObj;
    } else {
      this.getTaskDetailsObj1 = this.getTaskDetailsObj.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        }
        return false;
      });
    }
  }
  applyFilter7(column: string, event: Event, val: any): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.searchSubject.next({ column, filterValue, val });
  }
  searchTaskVWConfig = {
    width: '50%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  searchTaskVwFunction() {
    this.popupDataTitle.title = "Select Document No";
    this.isProcessing = true;
    this.appService.getQmsAllTasksVw("DOCS").subscribe((data: any) => {
      this.getTaskDetailsObj = data;
      this.getTaskDetailsObj1 = data;
      this.isProcessing = false;
    })
    this.visibleSearchTaskVwPopup = this.dialog.open(this.searchTaskVW, this.searchTaskVWConfig);
  }
  cancelAllTaskVwFunction() {
    this.getSelectedTaskId = null;
    this.getSelectedTaskNo = '';
    this.visibleSearchTaskVwPopup.close();
  }
  searchTaskVwChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      if (this.privvalue != undefined) {
        this.getTaskDetailsObj[this.privvalue].searchManagerChildCheckBoxs = false;
      }
      listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      this.getSelectedTaskId = listOfUsersVwDetails.taskId;
      this.getSelectedTaskNo = listOfUsersVwDetails.taskNo;
    } else {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = false;
      this.getSelectedTaskId = "";
      this.getSelectedTaskNo = null;
    }
    this.privvalue = idx;
  }
  addTaskVwGridDataFunction() {
    this.visibleSearchTaskVwPopup.close();
  }
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }
  genReport() {
    if (this.message.dmsReportButtonVal == 'Activity Vs User') {
      this.isProcessing = true;
      let folderPath = this.dmsGroupFoldersFieldData.folderPath;
      console.log("Folder Path Before Processing:", folderPath);
      if (folderPath && folderPath !== "Repository") {
        this.selectedFolderPath = folderPath;
      } else {
        this.selectedFolderPath = null;
      }
      this.selectedDocContainer = "";
      this.dynamicGridName = "PENDING_TASKS";
      this.dynamicGridViewName = "ONEQMS_PENDING_TASKS_VW";
      console.log('Selected Folder Path:', this.selectedFolderPath);
      this.getcallMethodPendingTasks();

    } else if (this.message.dmsReportButtonVal == 'Inventory') {
      this.isProcessing = true;
      let folderPath = this.dmsGroupFoldersFieldData.folderPath;
      console.log("Folder Path Before Processing:", folderPath);
      if (folderPath && folderPath !== "Repository") {
        this.selectedFolderPath = folderPath;
      } else {
        this.selectedFolderPath = null;
      }
      this.selectedDocContainer = "";
      if (this.physicalFolderLevel && this.distributedFolderLevel && (this.selectedFolderPath == null || this.selectedFolderPath == "Repository")) {
        this.selectedDocContainer = "";
      } else if (!this.physicalFolderLevel && this.distributedFolderLevel && (this.selectedFolderPath == null || this.selectedFolderPath == "Repository")) {
        this.selectedDocContainer = "Distributed";
      } else if (this.physicalFolderLevel && !this.distributedFolderLevel && (this.selectedFolderPath == null || this.selectedFolderPath == "Repository")) {
        this.selectedDocContainer = "Physical";
      }
      this.dynamicGridName = "DOCUMENT_INVENTORY";
      this.dynamicGridViewName = "DMS_DOCUMENTS_INVENTORY_VW";
      console.log('Selected Folder Path:', this.selectedFolderPath);
      this.getcallMethod();

    } else if (this.message.dmsReportButtonVal == 'Milestone') {
      this.selectedDocumentTypeName = "";
      if (this.selectedDocumentType.length != 0) {
        const codesArray: string[] = this.selectedDocumentType.join(',').split(",");
        this.selectedDocumentTypeName = codesArray.map(code => `'${code.trim()}'`).join(",");
      } else {
        this.selectedDocumentTypeName = null;
      }
      if (this.fromDate && this.toDate && (this.toDate <= this.fromDate)) {
        alert('To Date cannot be before From Date');
      } else {
        let data = {
          groupId: null,
          module: "DOCS",
          dateRangeAt: this.selectedDateRangeValue[0]?.valueExp ?? null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue[0]?.valueExp ?? null,
          taskType: this.selectedDocumentTypeName,
          taskNo: this.getSelectedTaskNo
        }

        this.isProcessing = true;
        this.columnList = "Task Type,Task ID,Sub Module,Version,Status,Created On,Completed On,Review Requested On,Review Completed On,Approval Requested On,Approval Completed On,Signoff Requested On,Signoff Completed On,Published On,Withdrawn On";
        forkJoin([
          this.appService.getTaskMilestonesIntervalsRepVw(data)]).subscribe(([MilestonesIntervalsRepVw]) => {
            this.tableReportDataList = MilestonesIntervalsRepVw;
            this.showTables = true;
            this.calculateTotalPages = this.collectionSize / this.perPage;
            this.pager.totalPages = undefined;
            this.collectionSize = this.tableReportDataList.length;
            this.totalPages = Math.ceil(this.tableReportDataList.length / this.itemsPerPage);
            this.setPage1(1, 0);
            this.showNoRecordFoundMilestone = this.tableReportDataList.length === 0;
            this.isProcessing = false;
          });
      }
      this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId();
      if (this.selectedDocumentTypeName != null) {
        this.whereValsForExcel += " AND TASK_TYPE IN (" + this.selectedDocumentTypeName + ")";
      }
      if (this.getSelectedTaskNo != null) {
        this.whereValsForExcel += " AND (TASK_NO='" + this.getSelectedTaskNo + "' OR PARENT_TASK_NO='" + this.getSelectedTaskNo + "')";
      }
    } else if (this.message.dmsReportButtonVal == 'Master Index') {
      let str = "";
      this.selectedFolderPath = this.selectedFolderForCreateDoc.folderPath;
      if (this.selectedFolderPath == "Repository" || this.selectedFolderPath == "undefined" || this.selectedFolderPath == undefined) {

        const field = document.getElementById('folderMasterAlert') as HTMLInputElement;
        field.style.color = 'red';
      } else {
        this.whereValsForExcel = "";
        this.whereValsForExcel += " WHERE ORG_ID=" + this.message.getOrgId();

        if (this.selectedFolderPath) {
          this.whereValsForExcel += " AND FOLDER_ID_PATH LIKE '" + this.selectedFolderPath + "%'";
        }
        this.selectedDocumentTypeName = "";
        if (this.selectedDocumentType.length != 0) {
          const codesArray: string[] = this.selectedDocumentType.join(',').split(",");
          this.selectedDocumentTypeName = codesArray.map(code => `'${code.trim()}'`).join(",");
        } else {
          this.selectedDocumentTypeName = null;
        }
        if (this.selectedDocumentTypeName) {
          str += " AND DOCUMENT_TYPE_CODE IN (" + this.selectedDocumentTypeName + ")";
        }
        if (!this.includeAmendmentsFlg && !this.associatedDocFlg) {
          str += " AND IS_ASSOCIATED_DOCUMENT_TYPE = 'N'";
        } else if (!this.includeAmendmentsFlg && this.associatedDocFlg) {
          str += " AND (IS_ASSOCIATED_DOCUMENT_TYPE = 'N' OR (IS_ASSOCIATED_DOCUMENT_TYPE = 'Y' AND IS_AMENDEMENT_DOC_TYPE = 'N'))";
        } else if (this.includeAmendmentsFlg && !this.associatedDocFlg) {
          str += " AND (IS_ASSOCIATED_DOCUMENT_TYPE = 'N' OR (IS_ASSOCIATED_DOCUMENT_TYPE = 'Y' AND IS_AMENDEMENT_DOC_TYPE = 'Y'))";
        }
        if (!this.individualDocFlg) {
          str += " AND BELONGS_TO_INDIVIDUAL='N'";
        }
        this.whereValsForExcel += str;
        if (str == "") {
          str += null;
        }
        this.isProcessing = true;
        let data = {

          str: str,
          folderPath: this.selectedFolderPath,
          // documentTypeCode:this.selectedDocumentType.join(',') ?? null,

          // val: "val"
        }

        forkJoin([
          this.appService.getDocumentRevisionHistoryBulkRepVw(data)]).subscribe(([MilestonesIntervalsRepVw]) => {
            this.tableReportDataList = MilestonesIntervalsRepVw;
            this.showNoRecordFoundMasterIndex = this.tableReportDataList.length === 0;
            this.showTables = true;
            this.calculateTotalPages = this.collectionSize / this.perPage;
            this.pager.totalPages = undefined;
            this.collectionSize = this.tableReportDataList.length;
            this.totalPages = Math.ceil(this.tableReportDataList.length / this.itemsPerPage);
            this.setPage1(1, 0);
            this.isProcessing = false;
          });
        this.columnList = "Document Type Name,Document No,Document Name,Version,Effective Date,Expiration Date";
      }
    } else if (this.message.dmsReportButtonVal == 'Distributed Folder Documents Report') {
      this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId();
      if (this.documentNo) {
        this.whereValsForExcel += " AND DOCUMENT_NO='" + this.documentNo + "'";
      }
      if (this.selectedDocumentType.length > 0) {
        const codesArray: string[] = this.selectedDocumentType.join(',').split(",");
        this.whereValsForExcel += " AND DOCUMENT_TYPE_CODE IN (" + codesArray.map(code => `'${code.trim()}'`).join(",") + ")";
      }
      this.isProcessing = true;
      let data = {

        documentNo: this.documentNo ?? null,
        documentTypeCode: this.selectedDocumentType.join(',') ?? null,
        val: "val"
      }

      forkJoin([
        this.appService.getFolderDocumentRepVw(data)]).subscribe(([folderDocumentRepList]) => {
          this.tableReportDataList = folderDocumentRepList;
          this.showTables = true;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.tableReportDataList.length;
          this.totalPages = Math.ceil(this.tableReportDataList.length / this.itemsPerPage);
          this.setPage1(1, 0);
          this.showNoRecordFoundFolderDocuments = this.tableReportDataList.length === 0;
          this.isProcessing = false;
        });
      this.columnList = "Document Type Name,Document No,Document Name,Version,Distributed From,Distributed To,Effective Date,Expiration Date,Created By,Created On,Updated By,Updated On";
    } else if (this.message.dmsReportButtonVal == 'Expiry Check') {
      this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId();
      if (this.documentNo) {
        this.whereValsForExcel += " AND DOCUMENT_NO='" + this.documentNo + "'";
      }
      if (this.selectedDocumentType.length > 0) {
        const codesArray: string[] = this.selectedDocumentType.join(',').split(",");
        this.whereValsForExcel += " AND DOCUMENT_TYPE_CODE IN (" + codesArray.map(code => `'${code.trim()}'`).join(",") + ")";
      }
      this.isProcessing = true;
      let data = {

        documentNo: this.documentNo ?? null,
        documentTypeCode: this.selectedDocumentType.join(',') ?? null,
        val: "val"
      }
      forkJoin([
        this.appService.getExpireCheckRepVw(data)]).subscribe(([expireCheckRepList]) => {
          this.tableReportExpireCheckList = expireCheckRepList;
          this.showTables = true;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.tableReportExpireCheckList.length;
          this.totalPages = Math.ceil(this.tableReportExpireCheckList.length / this.itemsPerPage);
          this.setPage2(1, 0);
          this.showNoRecordFoundExpireheck = this.tableReportExpireCheckList.length === 0;
          this.isProcessing = false;
        });
      this.columnList = "Expiry Status,Revised Before Expiry,Document Type Name,Document No,Document Name,Version,Status,Effective Date,Expiration Date,Folder Path,Created By,Created On,Updated By,Updated On";
    } else if (this.message.dmsReportButtonVal == 'Folder') {
      this.selectedFolderPath = this.selectedFolderForCreateDoc.folderPath;
      this.whereValsForExcel = "";
      this.whereValsForExcel += " WHERE ORG_ID=" + this.message.getOrgId();
      if (this.selectedFolderPath) {
        this.whereValsForExcel += " AND FOLDER_PATH LIKE '" + this.selectedFolderPath + "%' "
      }
      this.isProcessing = true;
      forkJoin([
        this.appService.getDocumentFolderRepVw(this.selectedFolderPath ? this.selectedFolderPath : null, "val")]).subscribe(([folderDocumentRepList]) => {
          this.tableReportDataList = folderDocumentRepList;
          this.showTables = true;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.tableReportDataList.length;
          this.totalPages = Math.ceil(this.tableReportDataList.length / this.itemsPerPage);
          this.setPage1(1, 0);
          this.isProcessing = false;
        });
      this.columnList = "Folder Name,Folder Code,Is Distributed Folder,Document Type Name,Folder Description,Override Document No Format At Folder,Document No Format,Document No Regeneration,Document No No Of Digits,Allow To Input Document No Manually,Allow To Input Version Manually,Group List,Status,Folder Name Path,All Parent Folder Status,Created By,Created On,Update Reason,Updated By,Updated On";
    }
  }
  getColor(documentId: string): string {
    const colors: { [key: string]: string } = {};
    let uniqueDocumentNos: string[] = [];
    this.pagedItems2.forEach((item: { documentId: string; }) => {
      if (!uniqueDocumentNos.includes(item.documentId)) {
        uniqueDocumentNos.push(item.documentId);
      }
    });
    uniqueDocumentNos.forEach((docNo, index) => {
      colors[docNo] = index % 2 === 0 ? 'even-color' : 'odd-color';
    });
    return colors[documentId] || '';
  }
  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportDataList.length, page, this.perPage, targetpage);
    if (this.tableReportDataList.length > 0) {
      this.pagedItems1 = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }
  setPage2(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportExpireCheckList.length, page, this.perPage, targetpage);
    if (this.tableReportExpireCheckList.length > 0) {
      this.pagedItems2 = this.tableReportExpireCheckList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall2(value: number) {
    this.perPage = value;
    this.setPage2(this.pager.currentPage, 0);
  }
  resetFunction() {
    this.selectedFolderPath = "Repository";
    this.dmsGroupFoldersFieldData.folderPath = "Repository";
    this.dmsGroupFoldersFieldData.folderName = "Repository";
    this.selectedFolderForCreateDoc = {};
    this.selectedDocumentType = [];
    this.selectedGroupValue = "";
    this.specificIntervalVal = false;
    this.pagedItems1 = [];
    this.pagedItems = [];
    this.collectionSize = 0;
    this.currentPage = 1;
    this.totalPages = 0;
    this.tableReportExpireCheckList = "";
    this.tableReportDataList = {};
    this.documentNo = null;
    this.getSelectedTaskId = "";
    this.getSelectedTaskNo = null;
    this.physicalFolderLevel = true;
    this.distributedFolderLevel = true;
    this.associatedDocFlg = true;
    this.individualDocFlg = true;
    this.includeAmendmentsFlg = true;
    this.tmsUserTrainingsRepVwDataForGrid = "";
    this.oneQmsUsersFieldData.managerId = null;
    this.oneQmsUsersFieldData.managerName = null;
  }
  cancelFunction() {
    this.message.breadcrumbData.fourthLevel = "";
    this.message.breadcrumbData.thirdLevel = "";
    this.router.navigate(['/dashboard/DmsMainReportComponent']);
  }
  onDateRangeValueSelect(item: any) {

  }
  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = selectedItems.length === 0 && field ? 'red' : '';
  }
  groupValueDropdown: any;
  selectBoxeForGroupValue() {
    this.groupValueDropdown = [];
    this.groupValueDropdown = this.groupdataList.map((group: { groupId: any; groupName: any; }) => ({
      valueExp: group.groupId,
      displayExp: group.groupName
    }));
  }
  specificIntervalFun(e: any) {
    if (e.checked) {
      this.specificIntervalVal = true;
      this.showSpecificInterval = true;
      this.selectedDateRangeValue = [{
        valueExp: 'CREATED',
        displayExp: 'CREATED'
      }];
      this.fromDate = null;
      this.toDate = null;
      this.selectedIntervalValue = [{
        valueExp: 'MONTH',
        displayExp: 'MONTH'
      }]
    } else {
      this.specificIntervalVal = false;
      this.showSpecificInterval = false;
    }
  }
  selectBoxForDateRange() {
    this.dateRangeValueDropdown = [];
    for (let i = 0; i < this.dropDownForDateRange.length; i++) {
      if (i == 0) {
        this.dateRangeValueDropdown = this.dateRangeValueDropdown.concat({
          valueExp: this.dropDownForDateRange[i].codelistCode,
          displayExp: this.dropDownForDateRange[i].codelistName
        });
      }
    }
  }
  dateFormat: any = this.message.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.message.organizationDetails?.dateFormat;
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  selectBoxForInterval() {
    this.intervalValueDropdown = [];
    this.intervalValueDropdown = this.dropDownForInterval.map((interval: { codelistCode: any; codelistName: any; }) => ({
      valueExp: interval.codelistCode,
      displayExp: interval.codelistName
    }));
  }
  //Excell & PDF

  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = [];
  }

  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  }
  pdfDetailSearchText: string = '';
  templateid: number;
  reportTemplateFieldValidation: any;
  reportLogoFieldValidation: any;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }

    }
  }
  reportName: any;
  isSaveReport: boolean = false;
  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else if (value == 'Pdf' && this.manuallyPicked && this.selectedColumns.length > 12) {
      alert('Selected columns exceeded the limit. Limit 12, Selected ' + this.selectedColumns.length);
    } else {
      this.appService.isProcessingRep = true;
      this.data = {};
      this.data1 = {};
      this.data2 = {};
      let tname = "";
      let colList = "";
      let fieldList = "";

      if (this.message.dmsReportButtonVal == 'Milestone') {
        tname = "ONEQMS_TASK_MILESTONES_INTERVALS_REP_VW";
        colList = "TASK_TYPE,TASK_ID,SUB_MODULE,VERSION,STATUS,CREATED_ON,COMPLETED_ON,REVIEW_REQUESTED_ON,REVIEW_COMPLETED_ON,APPROVAL_REQUESTED_ON,APPROVAL_COMPLETED_ON,SIGNOFF_REQUESTED_ON,SIGNOFF_COMPLETED_ON,PUBLISHED_ON,WITHDRAWN_ON";
        fieldList = "Task Type,Task ID,Sub Module,Version,Status,Created On,Completed On,Review Requested On,Review Completed On,Approval Requested On,Approval Completed On,Signoff Requested On,Signoff Completed On,Published On,Withdrawn On";
        this.data = {

          groupId: null
        }
        this.data1 = {

          tableOrViewName: tname,
          columnsList: colList,
          fieldLabelsList: fieldList,
          invisibleColumn: "",
          orderByClause: "",
          fieldSizeList: "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          status: "",
          codelistGroup: null,
          manualEntryDataFields: "EFFECTIVE_DATE,EXPIRATION_DATE",
          groupId: null,
          chartStatus: null,
          reModule: "qms",
          logoId: this.selectedReportLogoValue ?? 0,
          footer: this.selectedReportFooter,
          isSaveRep: this.isSaveReport ? 'Y' : 'N',
          reportName: this.reportName ?? "Report",
          currentStatus: "NA",
          groupName: "",
        }
        this.data2 = {

          groupId: null,
          module: "DOCS",
          dateRangeAt: this.selectedDateRangeValue[0]?.valueExp ?? null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue[0]?.valueExp ?? null,
          taskType: this.selectedDocumentTypeName,
          wherVal: this.whereValsForExcel + " ORDER BY CREATED_ON"
        }
        this.reportObj = { ...this.data1, ...this.data, ...this.data2 };

        if (value == 'Excel') {
          const pdfData = {
            ...this.reportObj, title: "Milestone", columns: [],
            "informationTab": {
              "Report Name": "Milestone",
              "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
            }
          }
          this.appService.downloadexcelForChart(pdfData, "Milestone.xlsx");
        } else {
          const pdfData = {
            ...this.reportObj, title: "Milestone", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
          }
          this.appService.downloadPdfForChart(pdfData, "Milestone.pdf");
        }
      } else if (this.message.dmsReportButtonVal == 'Inventory') {

        this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId();
        if (this.selectedFolderPath && this.selectedFolderPath != undefined) {
          this.whereValsForExcel += " AND FOLDER_PATH='" + this.selectedFolderPath + "'";
        }
        if (this.selectedDocumentType.length != 0) {
          this.selectedDocumentTypeName = "";
          const codesArray: string[] = this.selectedDocumentType.join(',').split(",");
          this.selectedDocumentTypeName = codesArray.map(code => `'${code.trim()}'`).join(",");
        } else {
          this.selectedDocumentTypeName = null;
        }

        if (this.selectedDocumentTypeName && this.selectedDocumentTypeName != undefined) {
          this.whereValsForExcel += " AND DOCUMENT_TYPE_CODE IN (" + this.selectedDocumentTypeName + ")";
        }

        if (this.selectedDocContainer && this.selectedDocContainer != undefined) {
          this.whereValsForExcel += " AND DOC_CONTAINER='" + this.selectedDocContainer + "'";
        }
        this.data = {

          gridName: this.dynamicGridName,
          groupId: null
        }
        this.appService.getDynamicGridHeaders(this.data).subscribe((response: any) => {

          response.orderByClause ??= "";


          this.data1 = {

            gridName: this.dynamicGridViewName,
            tableOrViewName: response.tableOrViewName ?? "",
            columnsList: response.columnsList ?? "",
            fieldLabelsList: response.fieldLabelsList ?? "",
            invisibleColumn: response.invisibleColumn ?? "",
            orderByClause: response.orderByClause ?? "",
            fieldSizeList: response.fieldSizeList ?? "",
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            selectedUserId: this.oneQmsUsersFieldData.managerId,
            selectedFolderPath: this.selectedFolderPath,
            selectedDocumentTypeName: this.selectedDocumentTypeName,
            selectedDocContainer: this.selectedDocContainer,
            manualEntryDataFields: `EFFECTIVE_DATE,EXPIRATION_DATE${response.manualEntryDataFields ? ',' + response.manualEntryDataFields : ''}`,
            wherVal: this.whereValsForExcel,
            reModule: "qmsInv",
            logoId: this.selectedReportLogoValue ?? 0,
            footer: this.selectedReportFooter,
            isSaveRep: this.isSaveReport ? 'Y' : 'N',
            reportName: this.reportName ?? "Report",
            currentStatus: "NA",
            groupName: "",
          }
          this.data2 = {

            groupId: null,
            module: "DOCS"
          }
          this.reportObj = { ...this.data1, ...this.data, ...this.data2 };
          debugger;
          if (value == 'Excel') {
            const pdfData = {
              ...this.reportObj, title: "Inventory", columns: [],
              "informationTab": {
                "Report Name": "Inventory",
                "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
              }
            }
            this.appService.downloadexcelForChart(pdfData, "Inventory.xlsx");
          } else {
            const pdfData = {
              ...this.reportObj, title: "Inventory", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray).slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
            }
            this.appService.downloadPdfForChart(pdfData, "Inventory.pdf");
          }
        });
      } else if (this.message.dmsReportButtonVal == 'Activity Vs User' || this.message.dmsReportButtonVal == 'Deleted' || this.message.dmsReportButtonVal == 'Withdrawn' || this.message.dmsReportButtonVal == 'Unblinded' || this.message.dmsReportButtonVal == 'Blinded') {

        this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId();

        if (this.message.dmsReportButtonVal == 'Activity Vs User') {
          this.whereValsForExcel += " AND MODULE_CODE='DOCS'";
          if (this.selectedFolderPath && this.selectedFolderPath != undefined) {

            this.whereValsForExcel += " AND FOLDER_ID_PATH LIKE '" + this.selectedFolderPath + "%'";
          }
          if (this.getSelectedUserId && this.getSelectedUserId != undefined) {
            this.whereValsForExcel += " AND PENDING_WITH_USERS='" + this.getSelectedUserId + "'";
          }
        }
        if (this.message.dmsReportButtonVal == 'Deleted') {
          this.whereValsForExcel += " AND STATUS='" + this.message.dmsReportButtonVal + "'";
        }
        if (this.message.dmsReportButtonVal == 'Withdrawn') {
          this.whereValsForExcel += " AND STATUS='" + this.message.dmsReportButtonVal + "'";
        }
        if (this.message.dmsReportButtonVal == 'Blinded') {
          this.whereValsForExcel += " AND IS_BLINDED='Y'";
        }
        if (this.message.dmsReportButtonVal == 'Unblinded') {
          this.whereValsForExcel += " AND IS_BLINDED='U'";
        }
        this.data = {

          gridName: this.dynamicGridName,
          groupId: null
        }
        this.appService.getDynamicGridHeaders(this.data).subscribe((response: any) => {

          response.orderByClause ??= "";
          this.data1 = {

            gridName: this.dynamicGridViewName,
            tableOrViewName: response.tableOrViewName ?? "",
            columnsList: response.columnsList ?? "",
            fieldLabelsList: response.fieldLabelsList ?? "",
            invisibleColumn: response.invisibleColumn ?? "",
            orderByClause: response.orderByClause ?? "",
            fieldSizeList: response.fieldSizeList ?? "",
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: response.invisibleColumn ?? "",
            fieldSizeListArray: [],
            selectedUserId: this.oneQmsUsersFieldData.managerId,
            selectedFolderPath: this.selectedFolderPath,
            selectedDocumentTypeName: this.selectedDocumentTypeName,
            selectedDocContainer: this.selectedDocContainer,
            manualEntryDataFields: `EFFECTIVE_DATE,EXPIRATION_DATE${response.manualEntryDataFields ? ',' + response.manualEntryDataFields : ''}`,
            wherVal: this.whereValsForExcel,
            reModule: "qmsInv",
            logoId: this.selectedReportLogoValue ?? 0,
            footer: this.selectedReportFooter,
            isSaveRep: this.isSaveReport ? 'Y' : 'N',
            reportName: this.reportName ?? "Report",
            currentStatus: "NA",
            groupName: "",
          }
          this.data2 = {

            groupId: null,
            module: "DOCS"
          }
          this.reportObj = { ...this.data1, ...this.data, ...this.data2 };
          console.log("this.reportObj==" + this.reportObj);
          debugger;
          if (value == 'Excel') {
            const pdfData = {
              ...this.reportObj, title: this.message.dmsReportButtonVal, columns: [],
              "informationTab": {
                "Report Name": this.message.dmsReportButtonVal,
                "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
              }
            }
            this.appService.downloadexcelForChart(pdfData, this.message.dmsReportButtonVal + ".xlsx");
          } else {
            const pdfData = {
              ...this.reportObj, title: this.message.dmsReportButtonVal, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray).slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
            }
            this.appService.downloadPdfForChart(pdfData, this.message.dmsReportButtonVal + ".pdf");
          }
        });
      } else if (this.message.dmsReportButtonVal == 'Distributed Folder Documents Report') {
        tname = "DMS_DISTRIBUTED_FOLDER_DOCUMENTS_REP_VW";
        colList = "DOCUMENT_TYPE_NAME,DOCUMENT_NO,DOCUMENT_NAME,VERSION,DISTRIBUTED_FROM,DISTRIBUTED_TO,EFFECTIVE_DATE,EXPIRATION_DATE,CREATED_BY_USER,CREATED_ON,UPDATED_BY_USER,UPDATED_ON";
        fieldList = "Document Type Name,Document No,Document Name,Version,Distributed From,Distributed To,Effective Date,Expiration Date,Created By,Created On,Updated By,Updated On";
        this.data = {

          groupId: null
        }
        this.data1 = {

          tableOrViewName: tname,
          columnsList: colList,
          fieldLabelsList: fieldList,
          invisibleColumn: "",
          orderByClause: "",
          fieldSizeList: "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          status: "",
          codelistGroup: null,
          manualEntryDataFields: "EFFECTIVE_DATE,EXPIRATION_DATE",
          groupId: null,
          chartStatus: null,
          reModule: "qms",
          logoId: this.selectedReportLogoValue ?? 0,
          footer: this.selectedReportFooter,
          isSaveRep: this.isSaveReport ? 'Y' : 'N',
          reportName: this.reportName ?? "Report",
          currentStatus: "NA",
          groupName: "",
        }
        this.data2 = {

          groupId: null,
          module: "DOCS",
          dateRangeAt: this.selectedDateRangeValue[0]?.valueExp ?? null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue[0]?.valueExp ?? null,
          taskType: this.selectedDocumentTypeName,
          wherVal: this.whereValsForExcel
        }

        this.reportObj = { ...this.data1, ...this.data, ...this.data2 };
        debugger;
        if (value == 'Excel') {
          const pdfData = {
            ...this.reportObj, title: "Distributed-Folder-Documents", columns: [],
            "informationTab": {
              "Report Name": "Distributed-Folder-Documents",
              "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
            }
          }
          this.appService.downloadexcelForChart(pdfData, "Distributed-Folder-Documents.xlsx");
        } else {
          const pdfData = {
            ...this.reportObj, title: "Distributed-Folder-Documents", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
          }
          this.appService.downloadPdfForChart(pdfData, "Distributed-Folder-Documents.pdf");

        }
      } else if (this.message.dmsReportButtonVal == 'Expiry Check') {
        tname = "DMS_DOCUMENTS_EXPIRY_CHECK_REP_VW";
        colList = "EXPIRY_STATUS,REVISED_BEFORE_EXPIRY,DOCUMENT_TYPE_NAME,DOCUMENT_NO,DOCUMENT_NAME,VERSION,STATUS,EFFECTIVE_DATE,EXPIRATION_DATE,FOLDER_PATH,CREATED_BY_USER,CREATED_ON,UPDATED_BY_USER,UPDATED_ON";
        fieldList = "Expiry Status,Revised Before Expiry,Document Type Name,Document No,Document Name,Version,Status,Effective Date,Expiration Date,Folder Path,Created By,Created On,Updated By,Updated On";
        this.data = {

          groupId: null
        }
        this.data1 = {

          tableOrViewName: tname,
          columnsList: colList,
          fieldLabelsList: fieldList,
          invisibleColumn: "",
          orderByClause: "",
          fieldSizeList: "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          status: "",
          codelistGroup: null,
          manualEntryDataFields: "EFFECTIVE_DATE,EXPIRATION_DATE",
          groupId: null,
          chartStatus: null,
          reModule: "qms",
          logoId: this.selectedReportLogoValue ?? 0,
          footer: this.selectedReportFooter,
          isSaveRep: this.isSaveReport ? 'Y' : 'N',
          reportName: this.reportName ?? "Report",
          currentStatus: "NA",
          groupName: "",
        }
        this.data2 = {

          groupId: null,
          module: "DOCS",
          dateRangeAt: this.selectedDateRangeValue[0]?.valueExp ?? null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue[0]?.valueExp ?? null,
          taskType: this.selectedDocumentTypeName,
          wherVal: this.whereValsForExcel
        }
        this.reportObj = { ...this.data1, ...this.data, ...this.data2 };
        debugger;
        if (value == 'Excel') {
          const pdfData = {
            ...this.reportObj, title: "Expiry-Check", columns: [],
            "informationTab": {
              "Report Name": "Expiry-Check",
              "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
            }
          }
          this.appService.downloadexcelForChart(pdfData, "Expiry-Check.xlsx");
        } else {
          const pdfData = {
            ...this.reportObj, title: "Expiry-Check", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
          }
          this.appService.downloadPdfForChart(pdfData, "Expiry-Check.pdf");

        }
      } else if (this.message.dmsReportButtonVal == 'Folder') {
        tname = "DMS_FOLDERS_REP_VW";
        colList = "FOLDER_NAME,FOLDER_CODE,IS_DISTRIBUTED_FOLDER,DOCUMENT_TYPE_NAME,FOLDER_DESCRIPTION,OVERRIDE_DOCUMENT_NO_FORMAT_AT_FOLDER,DOCUMENT_NO_FORMAT,DOCUMENT_NO_REGENERATION,DOCUMENT_NO_NO_OF_DIGITS,ALLOW_TO_INPUT_DOCUMENT_NO_MANUALLY,ALLOW_TO_INPUT_VERSION_MANUALLY,GROUP_LIST,STATUS,FOLDER_NAME_PATH,ALL_PARENT_FOLDER_STATUS,CREATED_BY_USER,CREATED_On,UPDATE_REASON,UPDATED_BY_USER,UPDATED_ON";
        fieldList = "Folder Name,Folder Code,Is Distributed Folder,Document Type Name,Folder Description,Override Document No Format At Folder,Document No Format,Document No Regeneration,Document No No Of Digits,Allow To Input Document No Manually,Allow To Input Version Manually,Group List,Status,Folder Name Path,All Parent Folder Status,Created By,Created On,Update Reason,Updated By,Updated On";
        this.data = {

          groupId: null
        }

        this.data1 = {

          tableOrViewName: tname,
          columnsList: colList,
          fieldLabelsList: fieldList,
          invisibleColumn: "",
          orderByClause: "",
          fieldSizeList: "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          status: "",
          codelistGroup: null,
          manualEntryDataFields: "EFFECTIVE_DATE,EXPIRATION_DATE",
          groupId: null,
          chartStatus: null,
          reModule: "qms",
          logoId: this.selectedReportLogoValue ?? 0,
          footer: this.selectedReportFooter,
          isSaveRep: this.isSaveReport ? 'Y' : 'N',
          reportName: this.reportName ?? "Report",
          currentStatus: "NA",
          groupName: "",
        }
        this.data2 = {

          groupId: null,
          module: "DOCS",
          dateRangeAt: this.selectedDateRangeValue[0]?.valueExp ?? null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue[0]?.valueExp ?? null,
          taskType: this.selectedDocumentTypeName,
          wherVal: this.whereValsForExcel
        }
        this.reportObj = { ...this.data1, ...this.data, ...this.data2 };
        debugger;
        if (value == 'Excel') {
          const pdfData = {
            ...this.reportObj, title: "Folder", columns: [],
            "informationTab": {
              "Report Name": "Folder",
              "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
            }
          }
          this.appService.downloadexcelForChart(pdfData, "Folder.xlsx");
        } else {
          const pdfData = {
            ...this.reportObj, title: "Folder", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
          }
          this.appService.downloadPdfForChart(pdfData, "Folder.pdf");
        }
      } else if (this.message.dmsReportButtonVal == 'Master Index') {
        tname = "DMS_DOCUMENT_INDEX_VW";
        colList = "DOCUMENT_TYPE_NAME,DOCUMENT_NO,DOCUMENT_NAME,VERSION,EFFECTIVE_DATE,EXPIRATION_DATE";
        fieldList = "Document Type Name,Document No,Document Name,Version,Effective Date,Expiration Date";
        this.data = {

          groupId: null
        }
        this.data1 = {

          tableOrViewName: tname,
          columnsList: colList,
          fieldLabelsList: fieldList,
          invisibleColumn: "",
          orderByClause: "",
          fieldSizeList: "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          status: "",
          codelistGroup: null,
          manualEntryDataFields: "EFFECTIVE_DATE,EXPIRATION_DATE",
          groupId: null,
          chartStatus: null,
          reModule: "qms",
          logoId: this.selectedReportLogoValue ?? 0,
          footer: this.selectedReportFooter,
          isSaveRep: this.isSaveReport ? 'Y' : 'N',
          reportName: this.reportName ?? "Report",
          currentStatus: "NA",
          groupName: "",
        }
        this.data2 = {

          groupId: null,
          module: "DOCS",
          dateRangeAt: this.selectedDateRangeValue[0]?.valueExp ?? null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue[0]?.valueExp ?? null,
          taskType: this.selectedDocumentTypeName,
          wherVal: this.whereValsForExcel
        }
        this.reportObj = { ...this.data1, ...this.data, ...this.data2 };
        debugger;
        if (value == 'Excel') {
          const pdfData = {
            ...this.reportObj, title: "Master-Index", columns: [],
            "informationTab": {
              "Report Name": "Master-Index",
              "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
            }
          }
          this.appService.downloadexcelForChart(pdfData, "Master-Index.xlsx");
        } else {
          const pdfData = {
            ...this.reportObj, title: "Master-Index", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
          }
          this.appService.downloadPdfForChart(pdfData, "Master-Index.pdf");
        }
      }
    }
  }
  openReportPopup(item: any) {
    if (this.message.dmsReportButtonVal == 'Activity Vs User' || this.message.dmsReportButtonVal == 'Inventory' || this.message.dmsReportButtonVal == 'Deleted' || this.message.dmsReportButtonVal == 'Withdrawn' || this.message.dmsReportButtonVal == 'Unblinded' || this.message.dmsReportButtonVal == 'Blinded') {
      this.excelPdf.dropDown = this.columnLists.fieldColumnarray.map((column: any) => ({ valueExp: column.fieldColumnarray, displayExp: column.fieldColumnarray }));
    } else {
      this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
    }
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.pdfSelection = false;
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
  }
  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.pdfSelection = this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }
  //end excell & pdf
  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};
  onSelect() {
    if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(this.selectedColumns);
  }
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }
  buttonClinkFun(value: any) {
    this.itemsPerPage = 5;
    this.currentPage = 1;
    this.totalPages = 0;
    this.maxSize = 3;
    this.collectionSize = 0;
    this.perPage = 10;
    this.calculateTotalPages = 0;
    this.resetFunction();
    if (value == "Default") {
      this.newdocumentTypeSelection = false;
      this.message.dmsReportButtonVal = value;
      this.message.breadcrumbData.thirdLevel = "";
      this.message.breadcrumbData.fourthLevel = "";
      this.router.navigate(['/dashboard/DmsMainReportComponent']);
    } else {
      this.newdocumentTypeSelection = false;
      this.message.dmsReportButtonVal = value;
      this.message.breadcrumbData.thirdLevel = value;
      this.message.breadcrumbData.fourthLevel = "";
      this.router.navigate(['/dashboard/DMSReportsComponent']);
      this.resetFunction();
      setTimeout(() => {
        this.ngOnChanges();
        this.refreshbreadcrumb = true;
      }, 0);
    }
  }
  refreshbreadcrumb: boolean = true;
  ngOnChanges() {
    // Don't immediately set refreshbreadcrumb to false if it was just set to true
    if (!this.refreshbreadcrumb) {
      this.refreshbreadcrumb = false;
    }

    if (this.message.dmsReportButtonVal == 'Deleted' || this.message.dmsReportButtonVal == 'Withdrawn' || this.message.dmsReportButtonVal == 'Unblinded' || this.message.dmsReportButtonVal == 'Blinded') {
      this.dynamicGridName = "ALL_DOCS_REP";
      this.dynamicGridViewName = "DMS_DOCUMENTS_REP_VW";
      this.getcallMethod();
      this.refreshbreadcrumb = true;
    } else {
      this.selectedFolderPath = "Repository";
      this.dmsGroupFoldersFieldData.folderPath = "Repository";
      this.dmsGroupFoldersFieldData.folderName = "Repository";
      this.appService.getDocumentTypeBasedOnModule("DOCS")
        .subscribe((data: any) => {
          this.dropDownFordocumentTypeList = data;
          this.documentTypeDropdown = this.dropDownFordocumentTypeList.map((documentType: { documentTypeCode: any; documentTypeName: any; }) => ({
            valueExp: documentType.documentTypeCode,
            displayExp: documentType.documentTypeName
          }));
        });
      this.appService.getDmsGroupsVwDetails().subscribe((response: any) => {
        this.groupdataList = response;
        this.selectBoxeForGroupValue();
      });
      this.appService.getCodeListsByGroup('DMS_REPORT_DATE_RANGE').subscribe((data: any) => {
        this.dropDownForDateRange = data
        this.selectBoxForDateRange();
      })
      this.appService.getCodeListsByGroup('REPORT_INTERVAL').subscribe((data: any) => {
        this.dropDownForInterval = data
        this.selectBoxForInterval();
      })
    }
  }

  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;

  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (const item of this.organizationReportImageDetails) {

              if (item.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: item.reportImageId,
                  displayExp: item.reportImageName
                });
              }
            }
          }
        }
      } else {
        for (const item of this.organizationReportImageDetails) {
          if (item.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: item.reportImageId,
              displayExp: item.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const item of this.reportLogoDropdown) {
          if (item.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = item.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next:
        (data: any) => {
          this.reportFooterDropdown1 = data;

          this.selectBoxForFooter();
          if (this.reportFooterDropdown.length > 0) {
            this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
          }

          this.isProcessing = false;
        }, error:
        (error: any) => {
          this.isProcessing = false;
        }
    }
    );
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes("DOCS")) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
        // }
      }
    }
  }
  ngOnInit() {
    this.route.params.subscribe(params => {
      this.ngOnChanges();
    });
    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe({
      next: (data: any) => {
        this.organizationReportImageDetails = data;
        this.appService.getQmsReportLogoByModuleAndGroupId("DOCS", 0).subscribe((data: any) => {
          this.dropDownDataForReportLogo = data;
          this.selectBoxForReportLogo();
          this.isProcessing = false;
        });
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })


    this.ngOnChangesReportFooter();
    this.searchSubject.pipe(
      debounceTime(2000),
      distinctUntilChanged()
    ).subscribe((params) => {
      this.executeFilter(params.column, params.filterValue, params.val);
    });
    this.appService.getCodeListsByGroup("DESIGNATION").subscribe((response: any) => {
      this.dropDownForDesignationCode = response;
      this.selectBoxeForDesignationCode();
    })
    this.appService.getCodeListsByGroup("DEPARTMENT").subscribe((response: any) => {
      this.dropDownForDepartmentCode = response;
      this.selectBoxeForDepartmentCode();
    })
  }
  executeFilter(column: string, filterValue: string, val: any) {
    this.isProcessing = true;

    setTimeout(() => {
      if (filterValue === '') {
        this.filteredGridData = this.tmsUserTrainingsRepVwDataForGrid;
      } else {
        this.filteredGridData = this.tmsUserTrainingsRepVwDataForGrid.filter((item: any) => {
          const columnValue = item[column];
          if (val === 'd') {
            if (!columnValue) return false;
            let dateStr = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            return dateStr ? dateStr.toLowerCase().includes(filterValue) : false;
          }
          else if (typeof columnValue === 'string') {
            return columnValue.toLowerCase().includes(filterValue);
          }
          else if (typeof columnValue === 'number') {
            return columnValue.toString().includes(filterValue);
          }
          return false;
        });
      }
      this.collectionSize = this.filteredGridData.length;
      this.pager.totalPages = Math.ceil(this.collectionSize / this.perPage);
      this.setPage(1, 0);

      this.isProcessing = false;
    }, 0);
  }
  //setting reorder start
  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.dynamicGridName, this.dynamicGridViewName, null, 0);
  }
  onChildValueEmitted() {
    this.getcallMethod();
  };



  //search user
  onNgModelChangeForUser(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }
  showUserSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByemailAddress: any = null;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];
  searchManagerChildCheckBoxs: boolean = false;
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  dropDownForDesignationCode: any = [];
  dropDownForDepartmentCode: any = [];
  selectedDesignationValue: any = null;
  groupSearchText: string = '';
  selectedDepartmentValue: any = null;
  @ViewChild('searchManager', { static: true }) searchManager: TemplateRef<any>;
  visibleSearchManagerPopup: MatDialogRef<TemplateRef<any>>;
  searchManagerFunction() {
    this.searchManagerChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByemailAddress = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.popupDataTitle.title = "Search User";
    this.visibleSearchManagerPopup = this.dialog.open(this.searchManager, this.searchManagerConfig);
  }

  searchManagerConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };


  selectBoxeForDesignationCode() {
    for (const item of this.dropDownForDesignationCode) {
      this.designationCodeDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }
  selectBoxeForDepartmentCode() {
    for (const item of this.dropDownForDepartmentCode) {
      this.departmentCodeDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }
  onDesignationCodeSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.selectedDesignationValue = item.valueExp;
    }
  }
  onDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.selectedDepartmentValue = item.valueExp;
    }
  }


  addManagerNameFunction() {
    this.oneQmsUsersFieldData.managerId = this.getSelectedUserId;
    this.oneQmsUsersFieldData.managerName = this.getSelectedUserName;
    this.onNgModelChange(this.oneQmsUsersFieldData.managerName, 'userName');
    this.visibleSearchManagerPopup.close();
  }

  cancelSearchManagerFunction() {
    this.getSelectedUserId = null;
    this.getSelectedUserName = '';
    if (this.operationFlag == 'ADD') {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Create User" : "";
    } else {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Update User" : "";
    }
    this.visibleSearchManagerPopup.close();
  }

  searchManagerGridDataFunction() {
    this.isProcessing = true;
    this.designationCodeValue = this.searchByDesignationCode ? this.searchByDesignationCode : null;
    this.departmentCodeValue = this.searchByDepartmentCode ? this.searchByDepartmentCode : null;
    if (this.searchByUserName) {
      this.searchByUserName = this.searchByUserName.toUpperCase();
    } else {
      this.searchByUserName = '';
    }
    this.searchOneQmsUserVwDetails = {
      userName: this.searchByUserName,
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      emailAddress: this.searchByemailAddress,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue,
      status: "active"
    };
    this.appService.getOneQmsUsersVwDetails(this.searchOneQmsUserVwDetails).subscribe((response: any) => {
      this.getOneQmsUsersVwDetailsTableData = response;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }

  resetSearchManagerGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByemailAddress = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.getOneQmsUsersVwDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }

  getSelectedUserId: any;
  getSelectedUserName: string;
  searchManagerChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      if (this.privvalue != undefined) {
        this.getOneQmsUsersVwDetailsTableData[this.privvalue].searchManagerChildCheckBoxs = false;
      }
      listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      this.getSelectedUserId = listOfUsersVwDetails.userId;
      this.getSelectedUserName = listOfUsersVwDetails.userName;
    } else {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }
    this.privvalue = idx;
  }
}
